import { type EntitiesFilters } from '../../../states/entities/filters';
import { type BetFilterState } from '../../../states/entities/filters';
import { type StateType } from '../../../states/index';
import { type Selector } from '../../../types/selectors';
import { getBetFilterIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesFilters: Selector<EntitiesFilters> = (state: StateType) =>
  selectEntitiesState(state).filters ?? emptyObject;

//#region state.entities.filters
type EntitiesFiltersSelectorProps = {
  betFilterId?: number;
};

export const selectEntitiesFiltersEntity: Selector<BetFilterState | undefined> = (
  state: StateType,
  props: EntitiesFiltersSelectorProps = {},
) => {
  const betFilterId = getBetFilterIdFromProps(state, props);

  if (betFilterId) {
    return selectEntitiesFilters(state)[betFilterId];
  }
};
//#endregion

//#region state.entities.filters[betFilterId]
export const selectEntitiesFiltersEntityBetFilterId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesFiltersSelectorProps = {},
) => selectEntitiesFiltersEntity(state, props)?.betFilterId;

export const selectEntitiesFiltersEntityBetFilterName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesFiltersSelectorProps = {},
) => selectEntitiesFiltersEntity(state, props)?.betFilterName;

export const selectEntitiesFiltersEntityBetFilterParentId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesFiltersSelectorProps = {},
) => selectEntitiesFiltersEntity(state, props)?.betFilterParentId;

export const selectEntitiesFiltersEntityIsDefault: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesFiltersSelectorProps = {},
) => selectEntitiesFiltersEntity(state, props)?.betFilterIsDefault;

export const selectEntitiesFiltersEntityDisplayOrder: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesFiltersSelectorProps = {},
) => selectEntitiesFiltersEntity(state, props)?.displayOrder;
//#endregion
